export const getDateTimeFieldProps = (operator: string) => {
    let min = 0;
    let max = 100;
    let placeholder = "Value";

    switch (operator) {
        case 'year':
        case 'iso_year':
            min = 1;
            max = 9999;
            placeholder = "Год (например, 2023)";
            break;
        case 'month':
            min = 1;
            max = 12;
            placeholder = "Месяц (1-12)";
            break;
        case 'day':
            min = 1;
            max = 31;
            placeholder = "День (1-31)";
            break;
        case 'week':
            min = 1;
            max = 53;
            placeholder = "Неделя (1-53)";
            break;
        case 'week_day':
            min = 0;
            max = 6;
            placeholder = "День недели (0-6, Воскресенье=0)";
            break;
        case 'iso_week_day':
            min = 1;
            max = 7;
            placeholder = "День недели по ISO (1-7, Понедельник=1)";
            break;
        case 'quarter':
            min = 1;
            max = 4;
            placeholder = "Квартал (1-4)";
            break;
        case 'hour':
            min = 0;
            max = 23;
            placeholder = "Час (0-23)";
            break;
        case 'minute':
        case 'second':
            min = 0;
            max = 59;
            placeholder = operator === 'minute' ? "Минута (0-59)" : "Секунда (0-59)";
            break;
    }

    return {
        type: "number",
        min: min,
        max: max,
        placeholder: placeholder,
    };
};
